<!--
 * @Description: 编辑
-->
<template>
  <Editor :type="1" />
</template>

<script>
import Editor from './components/editor'

export default {
  name: 'articleEdit',
  components: {
    Editor
  },
  data () {
    return {}
  },
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>
